import { Phone, MessageCircle } from "lucide-react";

const BG_IMG = `${process.env.REACT_APP_BACKEND_URL}/api/static/homepage/hero_recovery.png`;

/**
 * Final CTA section — dramatic dark banner with recovery image on the right,
 * "NEED A PART OR RECOVERY?" headline and dual CALL / WHATSAPP buttons.
 */
const HomeFinalCTA = () => (
  <section className="vd-final-cta" data-testid="home-final-cta">
    <div className="vd-final-cta-media" aria-hidden="true">
      <img src={BG_IMG} alt="" />
      <div className="vd-final-cta-overlay" />
    </div>
    <div className="vd-container relative">
      <div className="vd-final-cta-inner">
        <div className="vd-final-cta-icon">
          <Phone size={28} />
        </div>
        <div className="flex-1">
          <h2 className="vd-final-cta-title">
            NEED A <span className="vd-red">PART</span> OR <span className="vd-red">RECOVERY?</span>
          </h2>
          <p className="vd-final-cta-sub">
            Contact us today and let our team help you get back on the road.
          </p>
        </div>
        <div className="vd-final-cta-actions">
          <a href="tel:07979210250" className="vd-btn-primary vd-final-cta-btn" data-testid="final-cta-call">
            <Phone size={16} /> CALL US NOW
          </a>
          <a href="https://wa.me/447979210250" target="_blank" rel="noopener noreferrer" className="vd-btn-secondary vd-final-cta-btn vd-hero-secondary" data-testid="final-cta-whatsapp">
            <MessageCircle size={16} /> WHATSAPP US
          </a>
        </div>
      </div>
    </div>

    <style>{`
      .vd-final-cta { position: relative; overflow: hidden; background: #0d0d0d; color: #fff; padding: 40px 0; }
      .vd-final-cta-media { position: absolute; inset: 0; }
      .vd-final-cta-media img { width: 100%; height: 100%; object-fit: cover; object-position: right center; opacity: 0.6; }
      .vd-final-cta-overlay { position: absolute; inset: 0; background: linear-gradient(90deg, #0d0d0d 0%, rgba(13,13,13,0.85) 45%, rgba(13,13,13,0.15) 100%); }
      .vd-final-cta-inner { display: flex; align-items: center; gap: 18px; flex-wrap: wrap; padding: 18px 0; }
      .vd-final-cta-icon { width: 56px; height: 56px; border-radius: 999px; background: rgba(230,0,0,0.15); border: 2px solid var(--primary-red); color: var(--primary-red); display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
      .vd-final-cta-title { color: #fff !important; font-size: clamp(22px, 3vw, 32px); font-weight: 900; letter-spacing: 0.02em; margin: 0; line-height: 1.15; }
      .vd-final-cta-title .vd-red { color: var(--primary-red); }
      .vd-final-cta-sub { color: rgba(255,255,255,0.8); font-size: 15px; margin: 6px 0 0; }
      .vd-final-cta-actions { display: flex; gap: 10px; flex-wrap: wrap; }
      .vd-final-cta-btn { padding: 10px 18px !important; font-size: 13.5px !important; letter-spacing: 0.06em; }
      @media (max-width: 640px) { .vd-final-cta-inner { flex-direction: column; align-items: flex-start; text-align: left; } .vd-final-cta-actions { width: 100%; } .vd-final-cta-btn { flex: 1; justify-content: center; } }
    `}</style>
  </section>
);

export default HomeFinalCTA;
